<template>
  <div class="login">
    <v-app>
      <v-content>
        <v-container grid-list-md>
          <v-form>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Email" v-model="email"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Password"
                  type="password"
                  v-model="password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-btn @click="login">Login</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <v-snackbar top color="error" v-model="snackbar">
          Autenticazione fallita
        </v-snackbar>
      </v-content>
    </v-app>
  </div>
</template>
<script>
import Firebase from "@/firebase";
// import firebase from "firebase";
// import * as firebaseui from "firebaseui";
export default {
  data() {
    return {
      email: "",
      password: "",
      snackbar: false
    };
  },
  methods: {
    async login() {
      try {
        await Firebase.auth().signInWithEmailAndPassword(
          this.email,
          this.password
        );
      } catch (e) {
        this.snackbar = true;
      }
    }
  }
};
</script>
